import Vue from 'vue'
import VueRouter from 'vue-router'
import ConfirmPreconfiguredPage from '../views/ConfirmPreconfiguredPage.vue'
import ConfirmUsernamePage from '../views/ConfirmUsernamePage.vue'
import ConsentPage from '../views/ConsentPage.vue'
import ErrorPage from '../views/ErrorPage.vue'
import LoginLegalTextPage from '../views/LoginLegalTextPage.vue'
import LoginOtpPage from '../views/LoginOtpPage.vue'
import LoginPage from '../views/LoginPage.vue'
import LoginPassPage from '../views/LoginPassPage.vue'
import RegistrationPage from '../views/RegistrationPage.vue'
import ResetPassPage from '../views/ResetPassPage.vue'
import SetPassPage from '../views/SetPassPage.vue'
import SetCountryPage from '../views/SetCountryPage.vue'
import SetEmailPage from '../views/SetEmailPage.vue'
import LoginMmePage from '../views/LoginMmePage'
import RevokeSessionPage from '../views/RevokeSessionPage'
import SessionRevocationSuccess from '../views/RevokeSessionStatusPage'
import SetMobilePage from '../views/SetMobilePage.vue'

Vue.use(VueRouter)

export const ROUTE_START = 'GOTO_START'
export const ROUTE_REGISTRATION = 'GOTO_REGISTRATION'
export const ROUTE_CONFIRM_USERNAME = 'GOTO_CONFIRM_REG_USERNAME'

/* global showError */

console.debug('ShowError: ' + showError)

const routes = !showError ? [
  {
    name: ROUTE_START,
    path: '/',
    component: LoginPage,
    props: true
  }, {
    name: ROUTE_REGISTRATION,
    path: '/register',
    component: RegistrationPage,
    props: true
  }, {
    name: 'GOTO_LOGIN_PASS',
    path: '/login/pass',
    component: LoginPassPage,
    props: true
  }, {
    name: 'GOTO_LOGIN_OTP',
    path: '/login/otp',
    component: LoginOtpPage,
    props: true
  }, {
    name: 'GOTO_LOGIN_MME',
    path: '/login/mme',
    component: LoginMmePage,
    props: true
  }, {
    name: ROUTE_CONFIRM_USERNAME,
    path: '/confirm-username',
    component: ConfirmUsernamePage,
    props: true
  }, {
    name: 'GOTO_CONSENT',
    path: '/consent',
    component: ConsentPage,
    props: true
  }, {
    name: 'GOTO_LOGIN_LEGAL_TEXTS',
    path: '/legaltexts',
    component: LoginLegalTextPage,
    props: true
  }, {
    name: 'GOTO_RESET_PASS',
    path: '/reset/pass',
    component: ResetPassPage,
    props: true
  }, {
    name: 'GOTO_CONFIRM_PRECONFIGURED',
    path: '/confirm-preconfigured',
    component: ConfirmPreconfiguredPage,
    props: true
  }, {
    name: 'GOTO_SET_PASS_MFA',
    path: '/set/pass',
    component: SetPassPage,
    props: true
  }, {
    name: 'GOTO_SET_COUNTRY',
    path: '/country',
    component: SetCountryPage,
    props: true
  }, {
    name: 'GOTO_SET_EMAIL',
    path: '/email',
    component: SetEmailPage,
    props: true
  },
  {
    name: 'GOTO_SET_MOBILE',
    path: '/mobile',
    component: SetMobilePage,
    props: true
  },
  {
    name: 'GOTO_REVOKE_SESSION',
    path: '/revoke-session',
    component: RevokeSessionPage,
    props: true
  },
  {
    name: 'GOTO_REVOKE_SESSION_STATUS',
    path: '/revocation-status',
    component: SessionRevocationSuccess,
    props: true
  }
] : [
  {
    name: 'GOTO_ERROR',
    path: '/',
    component: ErrorPage,
    props: true
  }, {
    name: ROUTE_START,
    path: '/',
    component: ErrorPage,
    props: true
  }, {
    name: ROUTE_REGISTRATION,
    path: '/register',
    component: ErrorPage,
    props: true
  }, {
    name: 'GOTO_LOGIN_PASS',
    path: '/login/pass',
    component: ErrorPage,
    props: true
  }, {
    name: 'GOTO_LOGIN_OTP',
    path: '/login/otp',
    component: ErrorPage,
    props: true
  }, {
    name: 'GOTO_LOGIN_MME',
    path: '/login/mme',
    component: ErrorPage,
    props: true
  }, {
    name: ROUTE_CONFIRM_USERNAME,
    path: '/confirm-username',
    component: ErrorPage,
    props: true
  }, {
    name: 'GOTO_CONSENT',
    path: '/consent',
    component: ErrorPage,
    props: true
  }, {
    name: 'GOTO_LOGIN_LEGAL_TEXTS',
    path: '/legaltexts',
    component: ErrorPage,
    props: true
  }, {
    name: 'GOTO_RESET_PASS',
    path: '/reset/pass',
    component: ErrorPage,
    props: true
  }, {
    name: 'GOTO_CONFIRM_PRECONFIGURED',
    path: '/confirm-preconfigured',
    component: ErrorPage,
    props: true
  }, {
    name: 'GOTO_SET_PASS_MFA',
    path: '/set/pass',
    component: ErrorPage,
    props: true
  }, {
    name: 'GOTO_SET_COUNTRY',
    path: '/country',
    component: ErrorPage,
    props: true
  }, {
    name: 'GOTO_SET_EMAIL',
    path: '/email',
    component: ErrorPage,
    props: true
  },
  {
    name: 'GOTO_SET_MOBILE',
    path: '/mobile',
    component: ErrorPage,
    props: true
  },
  {
    name: 'GOTO_REVOKE_SESSION',
    path: '/revoke-session',
    component: ErrorPage,
    props: true
  }
]

const router = new VueRouter({
  routes
})

export default router
